// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2LOu5","title":"card_title__3ifzY","inActive":"card_inActive__19Lmo"};